/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Search: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM16.5709 17.5383C14.8136 19.0714 12.5153 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 12.3089 19.2175 14.435 17.9032 16.1277C17.9813 16.1715 18.0547 16.2266 18.1212 16.293L22.707 20.8788C23.0975 21.2694 23.0975 21.9025 22.707 22.293C22.3164 22.6836 21.6833 22.6836 21.2927 22.293L16.707 17.7073C16.6546 17.6549 16.6093 17.5982 16.5709 17.5383Z'
      fill='currentColor'
    />
  </React.Fragment>
)
